import { defineStore } from "pinia";
import vips from "@data/vip.json";
import insiders from "@data/insiders.json";
import free from "@data/free.json";
import tickets from "@data/tickets.json";
import {
  CURRENT_VIP,
  CURRENT_INSIDERS,
  CURRENT_TICKETS,
} from "@data/archive.js";

export const useArchiveStore = defineStore("archive", {
  state: () => ({
    CURRENT_VIP: CURRENT_VIP,
    CURRENT_INSIDERS: CURRENT_INSIDERS,
    CURRENT_TICKETS: CURRENT_TICKETS,
    vips: vips,
    freeTips: free,
    insiders: insiders,
    tickets: tickets,
  }),
  getters: {
    getVips: (state) => state.vips,
    getCurrentVip: (state) => state.CURRENT_VIP,
    getFreeTips: (state) => state.freeTips,
    getInsiders: (state) => state.insiders,
    getTickets: (state) => state.tickets,
    getCurrentInsiders: (state) => state.CURRENT_INSIDERS,
    getCurrentTickets: (state) => state.CURRENT_TICKETS,
  },
  actions: {},
});
